(function () {
  var STORAGE_KEY = "rozvelt_last_added_product_id";
  var debounceTimer = null;

  // Capture last added product_id from Add-to-cart form submits (best-effort)
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var pid =
      form.getAttribute("data-product-id") ||
      (form.dataset && form.dataset.productId) ||
      (form.closest("[data-product-id]") && form.closest("[data-product-id]").getAttribute("data-product-id"));

    if (pid) localStorage.setItem(STORAGE_KEY, String(pid));
  }, true);

  function formatMoneyFromCents(cents) {
    try {
      var currency =
        (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : "USD";
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency: currency });
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  async function addVariantToCart(variantId) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }
  async function featherSafeRefreshDrawer() {
  // Find the current drawer element (keep this element intact!)
  var drawer =
    document.querySelector("cart-drawer") ||
    document.getElementById("CartDrawer") ||
    document.querySelector("[data-cart-drawer]") ||
    document.querySelector(".cart-drawer");

  if (!drawer) return;

  // Try likely section names. One should return HTML.
  var sectionNames = ["cart-drawer", "cart-drawer-items", "cart"];
  var sectionHTML = null;

  for (var i = 0; i < sectionNames.length; i++) {
    var name = sectionNames[i];
    try {
      var res = await fetch("/?sections=" + encodeURIComponent(name), { credentials: "same-origin" });
      if (!res.ok) continue;
      var data = await res.json();
      if (data && data[name]) {
        sectionHTML = data[name];
        break;
      }
    } catch (e) {}
  }

  if (!sectionHTML) return;

  // Parse returned HTML and extract the new drawer content
  var doc = new DOMParser().parseFromString(sectionHTML, "text/html");

  // These are common “inner content” selectors across drawer themes
  var newInner =
    doc.querySelector("#CartDrawer .drawer__inner") ||
    doc.querySelector("#CartDrawer .cart-drawer__inner") ||
    doc.querySelector("#CartDrawer [data-drawer-inner]") ||
    doc.querySelector(".drawer__inner") ||
    doc.querySelector(".cart-drawer__inner");

  var currentInner =
    drawer.querySelector(".drawer__inner") ||
    drawer.querySelector(".cart-drawer__inner") ||
    drawer.querySelector("[data-drawer-inner]");

  // If we can’t confidently find inner content, do nothing (prevents breaking the drawer)
  if (!newInner || !currentInner) return;

  // Replace ONLY the inner content, not the whole drawer element
  currentInner.innerHTML = newInner.innerHTML;

  // Notify any listeners (harmless if unused)
  document.dispatchEvent(new CustomEvent("cart:updated"));
  document.dispatchEvent(new CustomEvent("cart:refresh"));
}

  async function refreshCartDrawer() {
  var drawerEl =
    document.querySelector("cart-drawer") ||
    document.getElementById("CartDrawer") ||
    document.querySelector("[data-cart-drawer]") ||
    document.querySelector(".cart-drawer");

  if (!drawerEl) return;

  var sectionCandidates = ["cart-drawer", "cart-drawer-items", "cart"];
  var html = null;

  for (var i = 0; i < sectionCandidates.length; i++) {
    var section = sectionCandidates[i];
    try {
      var res = await fetch("/?sections=" + encodeURIComponent(section), {
        credentials: "same-origin"
      });
      if (!res.ok) continue;

      var data = await res.json();
      if (data && data[section]) {
        html = data[section];
        break;
      }
    } catch (e) {}
  }

  if (html) {
    drawerEl.innerHTML = html;
  }

  document.dispatchEvent(new CustomEvent("cart:updated"));
  document.dispatchEvent(new CustomEvent("cart:refresh"));
}


  function render(container, products) {
    var wrap = container.querySelector(".cart-drawer-upsell__items");
    if (!wrap) return;

    wrap.innerHTML = products.map(function (p) {
      var img =
        (p.featured_image && p.featured_image.url) ? p.featured_image.url :
        (p.images && p.images.length ? p.images[0] : "");

      var price = (typeof p.price === "number") ? formatMoneyFromCents(p.price) : "";

      var variantId = null;
      if (p.variants && p.variants.length) {
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        variantId = v ? v.id : null;
      }

      return `
        <div class="cart-drawer-upsell__row">
          <a class="cart-drawer-upsell__item" href="${p.url}">
            <div class="cart-drawer-upsell__image">
              ${img ? `<img src="${img}" alt="${(p.title || "").replace(/"/g, "&quot;")}" loading="lazy">` : ""}
            </div>
            <div class="cart-drawer-upsell__meta">
              <div class="cart-drawer-upsell__name">${p.title || ""}</div>
              ${price ? `<div class="cart-drawer-upsell__price">${price}</div>` : ""}
            </div>
          </a>

          <button
            class="cart-drawer-upsell__add"
            type="button"
            data-upsell-add="true"
            ${variantId ? `data-variant-id="${variantId}"` : "disabled"}
          >Add</button>
        </div>
      `;
    }).join("");

    container.style.display = "";
  }

  async function loadUpsell(container) {
    // Use stored last-added id if we have one, else fallback to whatever Liquid put in data-product-id
    var stored = localStorage.getItem(STORAGE_KEY);
    var fallback = container.getAttribute("data-product-id");
    var productId = stored || fallback;

    var limit = container.getAttribute("data-limit") || "4";
    if (!productId) {
      container.style.display = "none";
      return;
    }

    var url = `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&intent=complementary`;

    try {
      var res = await fetch(url, { credentials: "same-origin" });
      var data = await res.json();
      var products = (data && data.products) ? data.products : [];

      if (!products.length) {
        container.style.display = "none";
        return;
      }

      render(container, products);
    } catch (e) {
      container.style.display = "none";
    }
  }

  function loadAllUpsells() {
    var nodes = document.querySelectorAll("[data-cart-drawer-upsell]");
    if (!nodes.length) return;

    nodes.forEach(function (c) {
      // avoid reloading repeatedly if already filled
      var items = c.querySelector(".cart-drawer-upsell__items");
      if (items && items.children && items.children.length > 0) return;
      loadUpsell(c);
    });
  }

  // One delegated click handler (stable)
  document.addEventListener("click", async function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[data-upsell-add="true"]') : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;
    if (btn.dataset.loading === "1") return;

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    try {
      btn.dataset.loading = "1";
      btn.disabled = true;
      btn.textContent = "Adding…";

      await addVariantToCart(variantId);
      await featherSafeRefreshDrawer();


      btn.textContent = "Added";
      setTimeout(function () { btn.textContent = "Add"; }, 900);

      // Let Feather/theme refresh drawer, but also refill if needed
      document.dispatchEvent(new CustomEvent("cart:updated"));
      setTimeout(loadAllUpsells, 250);
    } catch (err) {
      btn.textContent = "Error";
      setTimeout(function () { btn.textContent = "Add"; }, 1200);
    } finally {
      setTimeout(function () {
        btn.disabled = false;
        btn.dataset.loading = "0";
      }, 400);
    }
  });

  // Initial attempt
  document.addEventListener("DOMContentLoaded", function () {
    loadAllUpsells();
  });

  // Feather-safe: observe DOM for when cart drawer content is injected
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(loadAllUpsells, 200);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // If theme fires custom events, also listen
  document.addEventListener("cart:updated", function () {
    setTimeout(loadAllUpsells, 150);
  });
})();
